import { useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { PROJECT_ID } from '../constants';
import { useAuthData } from './use-auth-data';
import { sendLogoutMessage } from '../utils';
const useLogoutRequest = ({ httpClient, authUrl, configurationId }) => {
    const appId = useRef('');
    const authDataQuery = useAuthData({ authUrl, httpClient, configurationId });
    const { refetch, ...externalApps } = useQuery({
        queryKey: ['revoke-auth', configurationId],
        queryFn: () => {
            return httpClient(`${authUrl}/user/authentications/${authDataQuery.data[appId.current]}`, {
                method: 'delete',
                traceId: `${PROJECT_ID}-2`
            });
        },
        enabled: false,
        initialData: [],
        onSuccess: () => {
            sendLogoutMessage(appId.current);
        }
    });
    useEffect(() => {
        const idForDelete = authDataQuery.data[appId.current];
        if (authDataQuery.isFetched && idForDelete) {
            refetch();
        }
    }, [authDataQuery.isFetched]);
    const proxyFetch = (id) => {
        if (!id)
            return;
        authDataQuery.remove();
        externalApps.remove();
        appId.current = id;
        authDataQuery.fetch();
    };
    return {
        ...externalApps,
        isFetching: externalApps.isFetching || authDataQuery.isFetching,
        fetch: proxyFetch
    };
};
export default useLogoutRequest;
